import axios, { InternalAxiosRequestConfig } from 'axios';
import tokenData from '../../services/token_data.ts';

interface CustomRequestConfig extends InternalAxiosRequestConfig {
    skipAuth?: boolean
}

const api = axios.create({
    baseURL: 'https://libranza-web-backend.onrender.com/api/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    timeout: 30000,
    validateStatus: (status) => {
        return status >= 200 && status < 500;
    },
});

//Token
api.interceptors.request.use(async (config: CustomRequestConfig) => {
    const token = localStorage.getItem("token");

    if (token && !config.skipAuth) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;